// extracted by mini-css-extract-plugin
module.exports = {"reviewStars":"ZF4tc","star":"_1eli7","fullStar":"JIcGW","emptyStar":"_1K5Ab","medium":"_1NUfl"};